var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionstrelkaSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1443 0.329753C16.3384 0.134071 16.4074 0.0782131 16.4983 0.0428593C16.6437 -0.01369 16.7762 -0.0142555 16.9258 0.0410162C17.0405 0.0833863 17.147 0.187898 19.4696 2.53861C21.8015 4.89875 21.9901 5.07776 21.9996 5.26585C22.001 5.29406 21.9984 5.32248 21.9984 5.35849C21.9984 5.39451 22.001 5.42293 21.9996 5.45114C21.9901 5.63923 21.8015 5.81823 19.4696 8.17829C17.1481 10.5277 17.0405 10.6334 16.9258 10.6759C16.7736 10.7322 16.6542 10.732 16.5034 10.6749C16.4033 10.6371 16.344 10.5898 16.1421 10.387C15.855 10.0986 15.7945 9.99248 15.7949 9.77772C15.7951 9.68673 15.809 9.61033 15.8369 9.54733C15.8694 9.47402 16.3275 8.99832 17.8994 7.40585L19.0846 6.20512H0.846153C0.378836 6.20512 0 5.82629 0 5.35897C0 4.89165 0.378836 4.51282 0.846153 4.51282H19.0863L17.9016 3.31126C16.5328 1.92283 15.8705 1.23695 15.8439 1.18013C15.8153 1.11908 15.8047 1.05092 15.8052 0.928798C15.8059 0.701512 15.8465 0.629841 16.1443 0.329753Z",
    fill: "#FF9900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionstrelkaSlider);
export default __webpack_public_path__ + "static/media/Unionstrelka_slider.f2407b16f923bbfd72af428a68d15e99.svg";
export { ForwardRef as ReactComponent };